import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  NoteBatchTransactionCreate,
  NoteBatchTransactionCreateVariables,
} from './__generated__/NoteBatchTransactionCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_TRANSACTION_CREATE from './NoteBatchTransactionCreate.graphql';

type NotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  id: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const Notes: React.FC<NotesProps> = ({
  id,
  data,
  loading,
  listRefreshRequest,
}) => {
  return (
    <GenericNotesSection<
      any,
      NoteBatchTransactionCreate,
      NoteBatchTransactionCreateVariables
    >
      entityId={id}
      data={data}
      loading={loading}
      mutationDocument={NOTE_TRANSACTION_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
